import { render, staticRenderFns } from "./CustomIonInfiniteScroll.vue?vue&type=template&id=4ddbf98b&scoped=true&"
import script from "./CustomIonInfiniteScroll.vue?vue&type=script&lang=ts&"
export * from "./CustomIonInfiniteScroll.vue?vue&type=script&lang=ts&"
import style0 from "./CustomIonInfiniteScroll.vue?vue&type=style&index=0&id=4ddbf98b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddbf98b",
  null
  
)

export default component.exports